import './NotificationPopup.scss';
import { Link, useNavigate } from 'react-router-dom';
import GenericButton from '../common/button';
import { Nav } from 'react-bootstrap';
import MessageListComponent from './Messages/component/MessageListComponent';

function NotificationPopup({
  getNotificationCount,
  messageDetails,
  setShowNotification,
}) {
  const navigate = useNavigate();

  return (
    <div className="admin-popup-notification">
      <div className="popup-notification">
        <div className="notification-body d-flex justify-content-between">
          <div className="notification-item">
            <Link
              to={'/admin/Messages-Documents'}
              state={{
                showmymessage: true,
                notificationCount: getNotificationCount,
              }}
            >
              <span>My Messages</span>
              {getNotificationCount?.Message > 0 && (
                <span className="mymessage-count">
                  {getNotificationCount?.Message}
                </span>
              )}
            </Link>
          </div>
          <div className="notification-item">
            <Link
              to={'/admin/Messages-Documents'}
              state={{
                shownotification: true,
                notificationCount: getNotificationCount,
              }}
            >
              <span className="documents-count ml-3">
                {getNotificationCount?.Notification > 1
                  ? 'Updates/Reminders'
                  : 'Update/Reminder'}
              </span>
              {getNotificationCount?.Notification > 0 && (
                <span className="mymessage-count">
                  {getNotificationCount?.Notification}{' '}
                </span>
              )}
            </Link>
          </div>
          {/*My Messages
          <span className="mymessage-count">
            {getNotificationCount?.Message}
          </span> */}
        </div>
        <div className="my-message-border">
          <div className="scroll notificatication-popup-list-wrapper">
            <Nav
              variant="pills"
              className="messageNotificationItems message-mgt nav nav-pills"
            >
              {messageDetails?.Message?.slice(0, 3).map((item, id) => (
                <MessageListComponent
                  item={item}
                  key={id}
                  onClick={() =>
                    navigate('/admin/Messages-Documents', {
                      state: {
                        state: 'mymessage',
                        popUpMessage: item,
                        showmymessage: true,
                        notificationCount: getNotificationCount,
                      },
                    })
                  }
                />
              ))}
            </Nav>
          </div>
        </div>
        <div className="p-3 notification_bottom_class d-none">
          <Link
            to={'/admin/Messages-Documents'}
            state={{
              showmymessage: true,
              notificationCount: getNotificationCount,
            }}
          >
            <GenericButton
              onClick={() => setShowNotification(false)}
              variant="primary"
              className="View-all-button"
            >
              VIEW ALL
            </GenericButton>
          </Link>
          <Link
            to={'/admin/Messages-Documents'}
            state={{
              showdocuments: true,
              notificationCount: getNotificationCount,
            }}
          >
            <span className="documents-count ml-3">
              {/*{getNotificationCount?.Document}  */}
              Documents
              {/*{getNotificationCount?.Document > 1 ? 's' : ''} */}
            </span>
          </Link>
          <Link
            to={'/admin/Messages-Documents'}
            state={{
              shownotification: true,
              notificationCount: getNotificationCount,
            }}
          >
            <span className="documents-count ml-3">
              {getNotificationCount?.Notification}{' '}
              {getNotificationCount?.Notification > 1
                ? 'Updates/Reminders'
                : 'Update/Reminder'}
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotificationPopup;
